import { Component, Input } from '@angular/core';
import { AppliedReportOptions, AppliedReportOptionAssociations } from 'app/core/models/report.model';
import { keyedUserActivitiesOptions } from 'app/core/options/user-activities.opts';

@Component({
  selector: 'app-report-applied-user-activity-option',
  templateUrl: './report-applied-user-activity-option.component.html'
})
export class ReportAppliedUserActivityOptionComponent {
  @Input() name = 'activity';
  @Input() label = 'User Activities';
  @Input() options: AppliedReportOptions;
  @Input() optionAssociations: AppliedReportOptionAssociations;

  keyedUserActivitiesOptions = keyedUserActivitiesOptions;

  constructor() {}

  get displayNames() {
    const activities = [this.options[this.name]].filter(Boolean).flat();

    if (activities && activities.length > 0) {
      return activities.map(activity => {
        const userActivityOption = keyedUserActivitiesOptions[activity];
        return userActivityOption.display;
      });
    } else {
      return [];
    }
  }

  get names() {
    return this.displayNames.join(', ');
  }
}